"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LastNativeLoadManifestLoader = (function () {
    function LastNativeLoadManifestLoader() {
    }
    LastNativeLoadManifestLoader.prototype.notifyNativeLoad = function (nativeLoadData) {
        this.lastNativeLoadData = nativeLoadData;
    };
    return LastNativeLoadManifestLoader;
}());
exports.LastNativeLoadManifestLoader = LastNativeLoadManifestLoader;
